import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";


const toggleSelenoid = async (enabled) => {
  const user = getUserDetails();

  const res = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=turnSelenoid&companyId=${user.companyid}&useSelenoid=${enabled}`
  );

  return res.data;
};


const saveSelenoidUrl = async (url) => {
  const user = getUserDetails();

  const res = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=saveSelenoidSetup&companyId=${user.companyid}&selenoidUrl=${url}`
  );

  return res.data;
};

export const useToggleSelenoid = (options = {}) =>
  useMutation({
    mutationFn: toggleSelenoid,
    ...options,
  });

export const useSaveSelenoidUrl = (options = {}) =>
  useMutation({
    mutationFn: saveSelenoidUrl,
    ...options,
  });

  const getSelenoidFlag = async () => {
  const user = getUserDetails();
  const res = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getSelenoidFlag&companyId=${user.companyid}`
  );
  return res.data;
};

const getSelenoidUrl = async () => {
  const user = getUserDetails();
  const res = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getSelenoidUrl&companyId=${user.companyid}`
  );
  return res.data;
};

export const useGetSelenoidFlag = () =>
  useQuery({
    queryKey: ["selenoidFlag"],
    queryFn: getSelenoidFlag,
  });

export const useGetSelenoidUrl = () =>
  useQuery({
    queryKey: ["selenoidUrl"],
    queryFn: getSelenoidUrl,
  });